<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 16V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h4v3.13a1 1 0 001.55.83L16 21.33V26a1 1 0 001 1h3.84l2.58 1.84A1 1 0 0025 28v-1h3a1 1 0 001-1v-9a1 1 0 00-1-1zm-9.61 3.34L11 22.26V19H5V5h18v14h-7.11zM28 26h-4v2l-2.84-2H17v-5h6a2 2 0 002-2v-2h3z"/></svg>